module.exports = __webpack_public_path__ + "img/Verjuengung_1.01fd2cad.jpg";